import { render, staticRenderFns } from "./tabCustomerEvent.vue?vue&type=template&id=3184c014&scoped=true&"
import script from "./tabCustomerEvent.vue?vue&type=script&lang=js&"
export * from "./tabCustomerEvent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3184c014",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3184c014')) {
      api.createRecord('3184c014', component.options)
    } else {
      api.reload('3184c014', component.options)
    }
    module.hot.accept("./tabCustomerEvent.vue?vue&type=template&id=3184c014&scoped=true&", function () {
      api.rerender('3184c014', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/Information/components/partner/tab/tabCustomerEvent.vue"
export default component.exports